import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap';

const ConfirmModal = ({ modalText, onModalConfirm, modalOpenFlag, toggleModalClose, className }) => {

  const [isLoading, setIsLoading] = useState(false);

  const onConfirm = () => {
    setIsLoading(true);
    onModalConfirm().then(() => {
      setIsLoading(false);
    })
  }

  return (
    <Modal isOpen={ modalOpenFlag } className={className}>
      <ModalBody>
        { modalText }
      </ModalBody>
      <ModalFooter>
        <Button color="danger" disabled={ isLoading } onClick={ () => toggleModalClose(false) }>Cancel</Button>
        <Button color="success" disabled={ isLoading } onClick={ onConfirm }>
          {
            isLoading ? (
              <Spinner />
            ) : (
              "Confirm"
            )
          }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ConfirmModal;